import { SORTBY_HOME, SORTBY_SUBREGION_NSW, SORTBY_SUBREGION_VIC } from 'constants/offerList'
import { SORT_OPTION_HOME_PAGE } from 'constants/offerListFilters'
import { isManualSortingEnabledFor } from 'selectors/featuresSelectors'
import { DEFAULT_OFFER_LIST, DEFAULT_TOUR_FILTERS, NEW_DEFAULT_OFFER_LIST } from './constants'
import isAnyFilterApplied from 'lib/offer/filtersUtils'
import { OFFER_TYPE_TOUR_V2 } from 'constants/offer'
import { MAX_CAROUSEL_ITEM_COUNT } from './components/OfferCarousels/common/constants'
import { VALID_TOUR_OFFER_TYPES } from 'components/Recommendations/common/constant'

interface GetHomeOfferListParamsProps {
  region: string,
  subregion: string | undefined,
  sortOption?: App.OfferListSortByOptions
  filters?: App.OfferListFilters,
}

export const getHomeOfferListParams = ({
  region,
  subregion,
  sortOption,
  filters,
}: GetHomeOfferListParamsProps): App.OfferListFilters => {
  let sortBy: App.OfferListSortByOptions = SORT_OPTION_HOME_PAGE.value
  if (sortOption || !isManualSortingEnabledFor('home') || isAnyFilterApplied(filters)) {
    return {
      ...filters,
      ...DEFAULT_OFFER_LIST,
      sortBy: sortOption || sortBy,
    }
  }
  sortBy = SORTBY_HOME

  if (isManualSortingEnabledFor('subregion') && region === 'AU') {
    if (subregion === 'NSW') {
      sortBy = SORTBY_SUBREGION_NSW
    } else if (subregion === 'VIC') {
      sortBy = SORTBY_SUBREGION_VIC
    }
  }

  return {
    ...NEW_DEFAULT_OFFER_LIST,
    sortBy,
  }
}

export function getToursOfferListFilters(isManualSortingEnabled: boolean) {
  if (isManualSortingEnabled) {
    return {
      offerTypes: [OFFER_TYPE_TOUR_V2],
      sortBy: 'vertical-tour',
      limit: MAX_CAROUSEL_ITEM_COUNT,
    } as App.OfferListFilters
  }

  return DEFAULT_TOUR_FILTERS
}
export function hasRecentTourViews(highIntentOffers: Array<App.HighIntentOffer>) {
  const highIntentOfferTypes = new Set(highIntentOffers.map(offer => offer.offerType.toString()))
  return VALID_TOUR_OFFER_TYPES.some(tourType => highIntentOfferTypes.has(tourType))
}
